import { ReactElement, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { DEPRECATED_LIQUID_STAKING_TOKEN_ADDRESS } from 'modules/api/const';
import { useConnection } from 'modules/auth/hooks/useConnection';
import { DashboardRoutesConfig } from 'modules/dashboard/Routes';
import { useHasDeprecatedLSToken } from 'modules/deprecatedLiquidStaking/hooks/useHasDeprecatedLSToken';
import { Staking } from 'modules/liquidStaking/components/Staking';
import { LiquidStakingPoolContext } from 'modules/liquidStaking/LiquidStakingPoolContext';

export function Dashboard(): ReactElement {
  const { isConnected } = useConnection();
  const navigate = useNavigate();
  const { hasTokens, isLoading } = useHasDeprecatedLSToken();

  useEffect(() => {
    if (!isConnected) {
      navigate(DashboardRoutesConfig.dashboard.generatePath());
      return;
    }

    if (isConnected && !isLoading && !hasTokens) {
      navigate(DashboardRoutesConfig.dashboard.generatePath());
    }
  }, [hasTokens, isConnected, isLoading, navigate]);

  return (
    <LiquidStakingPoolContext.Provider
      value={DEPRECATED_LIQUID_STAKING_TOKEN_ADDRESS}
    >
      <Staking />
    </LiquidStakingPoolContext.Provider>
  );
}
